// eslint-disable-next-line no-unused-vars
var ItemTranslator = {
    "Ability Shield": "1881",
    "Abomasite": "674",
    "Absolite": "677",
    "Absorb Bulb": "545",
    "Adamant Crystal": "1777",
    "Adamant Orb": "135",
    "Adrenaline Orb": "846",
    "Aerodactylite": "672",
    "Aggronite": "667",
    "Aguav Berry": "162",
    "Air Balloon": "541",
    "Alakazite": "679",
    "Aloraichium Z": "803",
    "Altarianite": "755",
    "Ampharosite": "658",
    "Apicot Berry": "205",
    "Armor Fossil": "104",
    "Aspear Berry": "153",
    "Assault Vest": "640",
    "Audinite": "757",
    "Auspicious Armor": "2344",
    "Babiri Berry": "199",
    "Banettite": "668",
    "Beast Ball": "851",
    "Beedrillite": "770",
    "Belue Berry": "183",
    "Berry Juice": "43",
    "Berry Sweet": "1111",
    "Big Nugget": "581",
    "Big Root": "296",
    "Binding Band": "544",
    "Black Belt": "241",
    "Black Glasses": "240",
    "Black Sludge": "281",
    "Blastoisinite": "661",
    "Blazikenite": "664",
    "Blue Orb": "535",
    "Bluk Berry": "165",
    "Blunder Policy": "1121",
    "Booster Energy": "1880",
    "Bottle Cap": "795",
    "Bright Powder": "213",
    "Bug Gem": "558",
    "Bug Memory": "909",
    "Buginium Z": "787",
    "Burn Drive": "118",
    "Cameruptite": "767",
    "Cell Battery": "546",
    "Charcoal": "249",
    "Charizardite X": "660",
    "Charizardite Y": "678",
    "Charti Berry": "195",
    "Cheri Berry": "149",
    "Cherish Ball": "16",
    "Chesto Berry": "150",
    "Chilan Berry": "200",
    "Chill Drive": "119",
    "Chipped Pot": "1254",
    "Choice Band": "220",
    "Choice Scarf": "287",
    "Choice Specs": "297",
    "Chople Berry": "189",
    "Claw Fossil": "100",
    "Clear Amulet": "1882",
    "Clover Sweet": "1112",
    "Coba Berry": "192",
    "Colbur Berry": "198",
    "Cornerstone Mask": "2406",
    "Cornn Berry": "175",
    "Cover Fossil": "572",
    "Covert Cloak": "1885",
    "Cracked Pot": "1253",
    "Custap Berry": "210",
    "Damp Rock": "285",
    "Dark Gem": "562",
    "Dark Memory": "919",
    "Darkinium Z": "791",
    "Dawn Stone": "109",
    "Decidium Z": "798",
    "Deep Sea Scale": "227",
    "Deep Sea Tooth": "226",
    "Destiny Knot": "280",
    "Diancite": "764",
    "Dive Ball": "7",
    "Dome Fossil": "102",
    "Douse Drive": "116",
    "Draco Plate": "311",
    "Dragon Fang": "250",
    "Dragon Gem": "561",
    "Dragon Memory": "918",
    "Dragon Scale": "235",
    "Dragonium Z": "790",
    "Dread Plate": "312",
    "Dream Ball": "576",
    "Dubious Disc": "324",
    "Durin Berry": "182",
    "Dusk Ball": "13",
    "Dusk Stone": "108",
    "Earth Plate": "305",
    "Eevium Z": "805",
    "Eject Button": "547",
    "Eject Pack": "1119",
    "Electirizer": "322",
    "Electric Gem": "550",
    "Electric Memory": "915",
    "Electric Seed": "881",
    "Electrium Z": "779",
    "Enigma Berry": "208",
    "Eviolite": "538",
    "Expert Belt": "268",
    "Fairium Z": "793",
    "Fairy Feather": "2401",
    "Fairy Gem": "715",
    "Fairy Memory": "920",
    "Fast Ball": "492",
    "Fighting Gem": "553",
    "Fighting Memory": "904",
    "Fightinium Z": "782",
    "Figy Berry": "159",
    "Fire Gem": "548",
    "Fire Memory": "912",
    "Fire Stone": "82",
    "Firium Z": "777",
    "Fist Plate": "303",
    "Flame Orb": "273",
    "Flame Plate": "298",
    "Float Stone": "539",
    "Flower Sweet": "1113",
    "Flying Gem": "556",
    "Flying Memory": "905",
    "Flyinium Z": "785",
    "Focus Band": "230",
    "Focus Sash": "275",
    "Fossilized Bird": "1105",
    "Fossilized Dino": "1108",
    "Fossilized Drake": "1107",
    "Fossilized Fish": "1106",
    "Friend Ball": "497",
    "Full Incense": "316",
    "Galarica Cuff": "1582",
    "Galarica Wreath": "1592",
    "Galladite": "756",
    "Ganlon Berry": "202",
    "Garchompite": "683",
    "Gardevoirite": "657",
    "Gengarite": "656",
    "Ghost Gem": "560",
    "Ghost Memory": "910",
    "Ghostium Z": "789",
    "Glalitite": "763",
    "Gold Bottle Cap": "796",
    "Grass Gem": "551",
    "Grass Memory": "914",
    "Grassium Z": "780",
    "Grassy Seed": "884",
    "Great Ball": "3",
    "Grepa Berry": "173",
    "Grip Claw": "286",
    "Griseous Core": "1779",
    "Griseous Orb": "112",
    "Ground Gem": "555",
    "Ground Memory": "907",
    "Groundium Z": "784",
    "Gyaradosite": "676",
    "Haban Berry": "197",
    "Hard Stone": "238",
    "Heal Ball": "14",
    "Hearthflame Mask": "2408",
    "Heat Rock": "284",
    "Heavy Ball": "495",
    "Heavy-Duty Boots": "1120",
    "Helix Fossil": "101",
    "Heracronite": "680",
    "Hondew Berry": "172",
    "Houndoominite": "666",
    "Iapapa Berry": "163",
    "Ice Gem": "552",
    "Ice Memory": "917",
    "Ice Stone": "849",
    "Icicle Plate": "302",
    "Icium Z": "781",
    "Icy Rock": "282",
    "Incinium Z": "799",
    "Insect Plate": "308",
    "Iron Ball": "278",
    "Iron Plate": "313",
    "Jaboca Berry": "211",
    "Jaw Fossil": "710",
    "Kasib Berry": "196",
    "Kebia Berry": "190",
    "Kee Berry": "687",
    "Kelpsy Berry": "170",
    "Kangaskhanite": "675",
    "King's Rock": "221",
    "Kommonium Z": "926",
    "Lagging Tail": "279",
    "Lansat Berry": "206",
    "Latiasite": "684",
    "Latiosite": "685",
    "Lax Incense": "255",
    "Leaf Stone": "85",
    "Leek": "259",
    "Leftovers": "234",
    "Leppa Berry": "154",
    "Level Ball": "493",
    "Liechi Berry": "201",
    "Life Orb": "270",
    "Light Ball": "236",
    "Light Clay": "269",
    "Loaded Dice": "1886",
    "Lopunnite": "768",
    "Love Ball": "496",
    "Love Sweet": "1110",
    "Lucarionite": "673",
    "Lucky Punch": "256",
    "Lum Berry": "157",
    "Luminous Moss": "648",
    "Lunalium Z": "922",
    "Lure Ball": "494",
    "Lustrous Globe": "1778",
    "Lustrous Orb": "136",
    "Luxury Ball": "11",
    "Lycanium Z": "925",
    "Macho Brace": "215",
    "Magmarizer": "323",
    "Magnet": "242",
    "Mago Berry": "161",
    "Magost Berry": "176",
    "Mail": "137",
    "Malicious Armor": "1861",
    "Manectite": "682",
    "Maranga Berry": "688",
    "Marshadium Z": "802",
    "Master Ball": "1",
    "Masterpiece Teacup": "2404",
    "Mawilite": "681",
    "Meadow Plate": "301",
    "Medichamite": "665",
    "Mental Herb": "219",
    "Metagrossite": "758",
    "Metal Alloy": "2482",
    "Metal Coat": "233",
    "Metal Powder": "257",
    "Metronome": "277",
    "Mewnium Z": "806",
    "Mewtwonite X": "662",
    "Mewtwonite Y": "663",
    "Micle Berry": "209",
    "Mimikium Z": "924",
    "Mind Plate": "307",
    "Miracle Seed": "239",
    "Mirror Herb": "1883",
    "Misty Seed": "883",
    "Moon Ball": "498",
    "Moon Stone": "81",
    "Muscle Band": "266",
    "Mystic Water": "243",
    "Nanab Berry": "166",
    "Nest Ball": "8",
    "Net Ball": "6",
    "Never-Melt Ice": "246",
    "Nomel Berry": "178",
    "Normal Gem": "564",
    "Normalium Z": "776",
    "Occa Berry": "184",
    "Odd Incense": "314",
    "Old Amber": "103",
    "Oran Berry": "155",
    "Oval Stone": "110",
    "Pamtre Berry": "180",
    "Park Ball": "500",
    "Passho Berry": "185",
    "Payapa Berry": "193",
    "Pecha Berry": "151",
    "Persim Berry": "156",
    "Petaya Berry": "204",
    "Pidgeotite": "762",
    "Pikanium Z": "794",
    "Pikashunium Z": "836",
    "Pinap Berry": "168",
    "Pinsirite": "671",
    "Pixie Plate": "644",
    "Plume Fossil": "573",
    "Poison Barb": "245",
    "Poison Gem": "554",
    "Poison Memory": "906",
    "Poisonium Z": "783",
    "Poke Ball": "4",
    "Pomeg Berry": "169",
    "Power Anklet": "293",
    "Power Band": "292",
    "Power Belt": "290",
    "Power Bracer": "289",
    "Power Herb": "271",
    "Power Lens": "291",
    "Power Weight": "294",
    "Premier Ball": "12",
    "Primarium Z": "800",
    "Prism Scale": "537",
    "Protective Pads": "880",
    "Protector": "321",
    "Psychic Gem": "557",
    "Psychic Memory": "916",
    "Psychic Seed": "882",
    "Psychium Z": "786",
    "Punching Glove": "1884",
    "Qualot Berry": "171",
    "Quick Ball": "15",
    "Quick Claw": "217",
    "Quick Powder": "274",
    "Rabuta Berry": "177",
    "Rare Bone": "106",
    "Rawst Berry": "152",
    "Razor Claw": "326",
    "Razor Fang": "327",
    "Razz Berry": "164",
    "Reaper Cloth": "325",
    "Red Card": "542",
    "Red Orb": "534",
    "Repeat Ball": "9",
    "Ribbon Sweet": "1115",
    "Rindo Berry": "187",
    "Ring Target": "543",
    "Rock Gem": "559",
    "Rock Incense": "315",
    "Rock Memory": "908",
    "Rockium Z": "788",
    "Rocky Helmet": "540",
    "Room Service": "1122",
    "Root Fossil": "99",
    "Rose Incense": "318",
    "Roseli Berry": "686",
    "Rowap Berry": "212",
    "Rusted Shield": "1104",
    "Rusted Sword": "1103",
    "Sablenite": "754",
    "Sachet": "647",
    "Safari Ball": "5",
    "Safety Goggles": "650",
    "Sail Fossil": "711",
    "Salac Berry": "203",
    "Salamencite": "769",
    "Sceptilite": "753",
    "Scizorite": "670",
    "Scope Lens": "232",
    "Sea Incense": "254",
    "Sharp Beak": "244",
    "Sharpedonite": "759",
    "Shed Shell": "295",
    "Shell Bell": "253",
    "Shiny Stone": "107",
    "Shock Drive": "117",
    "Shuca Berry": "191",
    "Silk Scarf": "251",
    "Silver Powder": "222",
    "Sitrus Berry": "158",
    "Skull Fossil": "105",
    "Sky Plate": "306",
    "Slowbronite": "760",
    "Smooth Rock": "283",
    "Snorlium Z": "804",
    "Snowball": "649",
    "Soft Sand": "237",
    "Solganium Z": "921",
    "Soul Dew": "225",
    "Spell Tag": "247",
    "Spelon Berry": "179",
    "Splash Plate": "299",
    "Spooky Plate": "310",
    "Sport Ball": "499",
    "Starf Berry": "207",
    "Star Sweet": "1114",
    "Steelixite": "761",
    "Steel Gem": "563",
    "Steel Memory": "911",
    "Steelium Z": "792",
    "Stick": "259",
    "Sticky Barb": "288",
    "Stone Plate": "309",
    "Strange Ball": "1785",
    "Strawberry Sweet": "1109",
    "Sun Stone": "80",
    "Swampertite": "752",
    "Sweet Apple": "1116",
    "Syrupy Apple": "2402",
    "Tamato Berry": "174",
    "Tanga Berry": "194",
    "Tapunium Z": "801",
    "Tart Apple": "1117",
    "Terrain Extender": "879",
    "Thick Club": "258",
    "Throat Spray": "1118",
    "Thunder Stone": "83",
    "Timer Ball": "10",
    "Toxic Orb": "272",
    "Toxic Plate": "304",
    "TR00": "1130",
    "TR01": "1131",
    "TR02": "1132",
    "TR03": "1133",
    "TR04": "1134",
    "TR05": "1135",
    "TR06": "1136",
    "TR07": "1137",
    "TR08": "1138",
    "TR09": "1139",
    "TR10": "1140",
    "TR11": "1141",
    "TR12": "1142",
    "TR13": "1143",
    "TR14": "1144",
    "TR15": "1145",
    "TR16": "1146",
    "TR17": "1147",
    "TR18": "1148",
    "TR19": "1149",
    "TR20": "1150",
    "TR21": "1151",
    "TR22": "1152",
    "TR23": "1153",
    "TR24": "1154",
    "TR25": "1155",
    "TR26": "1156",
    "TR27": "1157",
    "TR28": "1158",
    "TR29": "1159",
    "TR30": "1160",
    "TR31": "1161",
    "TR32": "1162",
    "TR33": "1163",
    "TR34": "1164",
    "TR35": "1165",
    "TR36": "1166",
    "TR37": "1167",
    "TR38": "1168",
    "TR39": "1169",
    "TR40": "1170",
    "TR41": "1171",
    "TR42": "1172",
    "TR43": "1173",
    "TR44": "1174",
    "TR45": "1175",
    "TR46": "1176",
    "TR47": "1177",
    "TR48": "1178",
    "TR49": "1179",
    "TR50": "1180",
    "TR51": "1181",
    "TR52": "1182",
    "TR53": "1183",
    "TR54": "1184",
    "TR55": "1185",
    "TR56": "1186",
    "TR57": "1187",
    "TR58": "1188",
    "TR59": "1189",
    "TR60": "1190",
    "TR61": "1191",
    "TR62": "1192",
    "TR63": "1193",
    "TR64": "1194",
    "TR65": "1195",
    "TR66": "1196",
    "TR67": "1197",
    "TR68": "1198",
    "TR69": "1199",
    "TR70": "1200",
    "TR71": "1201",
    "TR72": "1202",
    "TR73": "1203",
    "TR74": "1204",
    "TR75": "1205",
    "TR76": "1206",
    "TR77": "1207",
    "TR78": "1208",
    "TR79": "1209",
    "TR80": "1210",
    "TR81": "1211",
    "TR82": "1212",
    "TR83": "1213",
    "TR84": "1214",
    "TR85": "1215",
    "TR86": "1216",
    "TR87": "1217",
    "TR88": "1218",
    "TR89": "1219",
    "TR90": "1220",
    "TR91": "1221",
    "TR92": "1222",
    "TR93": "1223",
    "TR94": "1224",
    "TR95": "1225",
    "TR96": "1226",
    "TR97": "1227",
    "TR98": "1228",
    "TR99": "1229",
    "Twisted Spoon": "248",
    "Tyranitarite": "669",
    "Ultra Ball": "2",
    "Ultranecrozium Z": "923",
    "Unremarkable Teacup": "2403",
    "Up-Grade": "252",
    "Utility Umbrella": "1123",
    "Venusaurite": "659",
    "Wacan Berry": "186",
    "Water Gem": "549",
    "Water Memory": "913",
    "Water Stone": "84",
    "Waterium Z": "778",
    "Watmel Berry": "181",
    "Wave Incense": "317",
    "Weakness Policy": "639",
    "Wellspring Mask": "2407",
    "Wepear Berry": "167",
    "Whipped Dream": "646",
    "White Herb": "214",
    "Wide Lens": "265",
    "Wiki Berry": "160",
    "Wise Glasses": "267",
    "Yache Berry": "188",
    "Zap Plate": "300",
    "Zoom Lens": "276",
    "Berserk Gene": "0",
    "Berry": "155",
    "Bitter Berry": "156",
    "Burnt Berry": "153",
    "Gold Berry": "158",
    "Ice Berry": "152",
    "Mint Berry": "150",
    "Miracle Berry": "157",
    "Mystery Berry": "154",
    "Pink Bow": "251",
    "Polkadot Bow": "251",
    "PRZ Cure Berry": "149",
    "PSN Cure Berry": "151",
    "Crucibellite": "-1",
    "Vile Vial": "-2",
    "Chesnaughtite": "2550",
    "Clefablite": "2551",
    "Delphoxite": "2552",
    "Dragoninite": "2553",
    "Drampanite": "2554",
    "Emboarite": "2555",
    "Excadrillite": "2556",
    "Feraligite": "2557",
    "Floettite": "2558",
    "Greninjite": "2559",
    "Golurkite": "2560",
    "Hawluchanite": "2561",
    "Meganiumite": "2562",
    "Meowsticite": "2563",
    "Starmiite": "2564",
    "Victreebelite": "2565",
    "Skarmoryite": "2566",
    "Chandelurite": "2567",
    "Zygardite": "2568",
    "Glimmoranite": "2569",
    "Crabominite": "2570",
    "Raichuite X": "2571",
    "Raichuite Y": "2572",
    "Chimechite": "2573",
    "Absolite Z": "2574",
    "Staraptorite": "2575",
    "Garchompite Z": "2576",
    "Lucarionite Z": "2577",
    "Heatranite": "2578",
    "Darkranite": "2579",
    "Golisopite": "2580",
    "Magearnite": "2581",
    "Zeraorite": "2582",
    "Scovillainite": "2583",
    "Tatsugirite": "2584",
    "Baxcalibrite": "2585",
}

export default ItemTranslator;